import { Checkbox, FormControlLabel } from "@mui/material";
import { JobAdIntegrationType } from "../types/common";

type Props = {
  integrationType: JobAdIntegrationType | undefined;
  label: string;
  onPublishSelection?: (integration: JobAdIntegrationType) => void;
  isSelected?: boolean;
  disabled?: boolean;
};

const PublishCheckBox = ({
  integrationType,
  label,
  onPublishSelection,
  isSelected,
  disabled,
}: Props) => {
  return (
    <FormControlLabel
      sx={{ ml: "auto" }}
      label={label}
      control={
        <Checkbox
          disabled={disabled}
          checked={isSelected}
          inputProps={{ "aria-label": "controlled" }}
          onChange={() => {
            integrationType &&
              onPublishSelection &&
              onPublishSelection(integrationType);
          }}
        />
      }
    />
  );
};

export default PublishCheckBox;
